export default {"src":"/_next/static/image/public/images/ic_schedule_express_delivery.f865caf81771e0cd47ad417109e36173.svg","height":57,"width":56};